/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './subscription-payment.reducer';

export const SubscriptionPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const subscriptionPaymentEntity = useAppSelector(state => state.subscriptionPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="subscriptionPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.subscriptionPayment.detail.title">SubscriptionPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.id}</dd>
          <dt>
            <span id="paymentType">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.paymentType">Payment Type</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.paymentType}</dd>
          <dt>
            <span id="paymentReason">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.paymentReason">Payment Reason</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.paymentReason}</dd>
          <dt>
            <span id="gatewayVendor">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.gatewayVendor">Gateway Vendor</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.gatewayVendor}</dd>
          <dt>
            <span id="transactionId">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.transactionId">Transaction Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.transactionId}</dd>
          <dt>
            <span id="customerId">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.customerId">Customer Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.customerId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.subscriptionPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{subscriptionPaymentEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.subscriptionPayment.subscriptionPlan">Subscription Plan</Translate>
          </dt>
          <dd>{subscriptionPaymentEntity.subscriptionPlan ? subscriptionPaymentEntity.subscriptionPlan.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/subscription-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/subscription-payment/${subscriptionPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubscriptionPaymentDetail;
